import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsernamePrefix } from '../../models/usernamePrefix';
import { ITrialService } from './trial.service.interface';
import { TrialRegistration } from '../../models/trialRegistration';
import { ConfigurationService } from '../configuration.service';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../auth.service';
import { TrialOrgInfo } from '../../models/trialOrgInfo';

@Injectable({
  providedIn: 'root'
})
export class TrialService implements ITrialService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private configService: ConfigurationService, private auth: AuthenticationService) {

  }

  isPrefixAvailable(prefix: string): Observable<UsernamePrefix> {
    return this.http.post<UsernamePrefix>(`${this.configService.config.apiBaseUrl}/newtrials/v1/prefixAvailable`, { Prefix: prefix }, this.httpOptions);
  }

  getPrefixSuggestion(orgName: string): Observable<UsernamePrefix> {
    return this.http.post<UsernamePrefix>(`${this.configService.config.apiBaseUrl}/newtrials/v1/suggestprefix`, { Prefix: orgName }, this.httpOptions);
  }

  registerTrial(model: TrialRegistration): Observable<any> {
    return this.http.post(`${this.configService.config.apiBaseUrl}/newtrials/v1/register`, model, this.httpOptions);
  }

  startTrial(orgPrefix: string): Observable<any> {
    return this.http.post(`${this.configService.config.billingApiBaseUrl}/AccountInfo/trial`, { OrganizationPrefix: orgPrefix }, this.httpOptions);
  }

  startTrialWithPaymentMethod(orgPrefix: string, paymentMethodId: string, selectedPlan: string): Observable<any> {
    return this.http.post(`${this.configService.config.billingApiBaseUrl}/AccountInfo/trial/paymentmethod`, { OrganizationPrefix: orgPrefix, PaymentMethodId: paymentMethodId, SelectedPlan: selectedPlan }, this.httpOptions);
  }

  startExistingTrial(orgPrefix: string): Observable<any> {
    return this.http.post(`${this.configService.config.billingApiBaseUrl}/AccountInfo/trial/existing`, { OrganizationPrefix: orgPrefix }, this.auth.getAuthHttpOptions());
  }

  getStripePublicKey(): Observable<string> {
    return this.http.get<string>(`${this.configService.config.billingApiBaseUrl}/AccountInfo/trial/stripepublickey`, this.httpOptions);
  }

  enablePinnacle(orgPrefix: string, userId: string): Observable<TrialOrgInfo> {
    return this.http.post<TrialOrgInfo>(`${this.configService.config.apiBaseUrl}/newtrials/v1/enablePinnacle`, { UsernamePrefix: orgPrefix, UserId: userId }, this.auth.getAuthHttpOptions());
  }

  submitHubspotPartialForm(model: TrialRegistration): Observable<any> {
    return this.http.post(`${this.configService.config.apiBaseUrl}/newtrials/v1/hubspot/partialTrial`, model, this.httpOptions)
      .pipe(map((result: any) => <boolean>result));
  }  

  submitHubspotCombinedForm(model: TrialRegistration): Observable<any> {
    return this.http.post(`${this.configService.config.apiBaseUrl}/newtrials/v1/hubspot/combinedTrial`, model, this.httpOptions)
      .pipe(map((result: any) => <boolean>result));
  }

  submitHubspotPinnacleForm(model: TrialOrgInfo): Observable<any> {
    return this.http.post(`${this.configService.config.apiBaseUrl}/newtrials/v1/hubspot/pinnacleTrial`, model, this.httpOptions)
      .pipe(map((result: any) => <boolean>result));
  }
}







